import i18next from 'i18next';
import React from 'react';

// Total column for entities (uses totalToProduce directly)
import { convertUnits, convertEntityQuantityToInpulseUnit } from '@commons/utils/conversion';
import { EntityTimeSlotCellContainer } from '../styledComponents';
import { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';
import { formatNumber } from '@commons/DisplayNumber';
import Text from '@commons/Text';

export const getEntityTotalColumn = (commonColumnsProps) => ({
  ...commonColumnsProps,
  field: 'total',
  type: 'number',
  headerName: i18next.t('PRODUCTION.PLANNING.TO_PRODUCE_TOTAL'),
  minWidth: 160,
  flex: 0,
  headerAlign: 'left',
  sortable: false,
  resizable: false,
  renderCell: (params) => {
    const { row } = params;

    const totalToProduce = row.totalToProduce || 0;

    const convertedUnit = convertUnits(row.unit, true, totalToProduce);
    const convertedTotalToProduce = formatNumber(
      convertEntityQuantityToInpulseUnit(totalToProduce < 0 ? 0 : totalToProduce, row.unit),
      2,
    );

    if (row.isIngredient || !row.batchProduction) {
      return (
        <EntityTimeSlotCellContainer isTotalCell>
          <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_SMALL_BOLD}>
            {convertedTotalToProduce} {convertedUnit}
          </Text>
        </EntityTimeSlotCellContainer>
      );
    }

    const convertedQuantity = formatNumber(
      convertEntityQuantityToInpulseUnit(row.unitQuantity, row.unit),
      2,
    );

    return (
      <EntityTimeSlotCellContainer isTotalCell>
        <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_SMALL_BOLD}>
          {convertedTotalToProduce} {convertedUnit}
        </Text>
        <Text
          color={ENUM_COLORS.IP_BLACK_5}
          font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}
        >{`(${formatNumber(
          convertedTotalToProduce / convertedQuantity,
          2,
        )} x ${convertedQuantity} ${convertedUnit})`}</Text>
      </EntityTimeSlotCellContainer>
    );
  },
});
